import { Car } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { TransferRoutes } from "./routes";
import { TransferPermissions } from "./permissions";

export const transferNav: INavItem = {
  labelKey: "nav.transfers",
  icon: Car,
  path: TransferRoutes.LIST,
  permissions: [TransferPermissions.READ],
};
